import { Component,HostListener, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import {FormGroup, Validators } from '@angular/forms';
import { ViewChild, ElementRef} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { AspRatecardSettingService } from './asp-ratecard-setting.service';
import { AspLoadingService } from '../asp-loading/asp-loading.service';



@Component({
  selector: 'app-asp-ratecard-setting',
  templateUrl: './asp-ratecard-setting.component.html',
  styleUrls: ['./asp-ratecard-setting.component.scss']
})
export class AspRatecardSettingComponent implements OnInit {
  displayedColumns: string[] = ['carSize', 'labourItem', 'mrp', 'status'];
  tableData = new MatTableDataSource<any>();
  // companies = ['Toyota', 'Honda', 'Ford', 'BMW'];
  companies: string[] = [];
  selectedCompany : any;
  showAddForm = false;
editIndex: number | null = null;
editItem: any = {};
listData: any;
rateCardTypes: string[] = [];
rateCards: { [key: string]: any[] } = {};


   newItem = {
    carSize: '',
    labourItem: '',
    mrp: '',
    status: ''
  };

dataMap: { [key: string]: any[] } = {};
showLabelPopup: boolean = false;
labelName: string = '';


// displayedColumns: string[] = ['carSize', 'labourItem', 'mrp', 'status'];
//   tableData = new MatTableDataSource<any>();

  constructor(
    private aspRatecardSettingService : AspRatecardSettingService,
    private toastr: ToastrService,
    private aspLoadingService: AspLoadingService,
  ) { }

  ngOnInit(): void {
    this.labourList();
     this.loadTableData();
     
    
  }
onCompanyChange() {
    localStorage.setItem('selectedCompany', this.selectedCompany);

  this.loadTableData();
  this.showAddForm = false;
 this.editIndex = null;
}

loadTableData() {
  this.listData = this.dataMap[this.selectedCompany] || [];
  // console.log("this.datamap--",this)
  const selectedData = this.dataMap[this.selectedCompany] || [];
  // console.log("selected labours at load table time",selectedData);
  this.tableData.data = selectedData;
  this.listData = selectedData;
  // Add this line
}



addNewItem() {
  const labourAmount = Number(this.newItem.mrp.replace(/[^0-9.-]+/g, ''));

  const payload = {
    garageKey: localStorage.getItem('garageKey'),
    // userKey: localStorage.getItem('spareUserKey'),
    labourName: this.newItem.labourItem || '',
    labourAmount: isNaN(labourAmount) ? 0 : labourAmount,
    carSize: this.newItem.carSize || '',
    rateCardType: this.selectedCompany || '',
    status: this.newItem.status ? 1 : 0
  };

  // console.log('Submitting labour item:', payload);

 this.aspRatecardSettingService.addLabourItem(payload).subscribe(
  (response: any) => {
    if (response.code === 200) {
      const companyData = this.dataMap[this.selectedCompany] || [];

      const newEntry = {
        id: response.data?.id || null, // if API returns the id
        labourId: response.data?.labourId || null,
        garageKey: payload.garageKey,
        labourName: payload.labourName,
        labourAmount: payload.labourAmount,
        hsnCode: '',
        gstRate: 0.18, // Set defaults or fetch if needed
        rateCardType: payload.rateCardType,
        carSize: payload.carSize,
        status: payload.status,
      };

      companyData.push(newEntry);
      this.dataMap[this.selectedCompany] = companyData;
      this.loadTableData();

      this.newItem = { carSize: '', labourItem: '', mrp: '', status: '1' };
      this.showAddForm = false;
      this.toastr.success('Labour item added successfully');
    } else if (response.code === 906) {
      this.toastr.error('Labour item already exists.');
    } else {
      this.toastr.error('Failed to add labour item. Please try again.');
    }
  },
  (error) => {
    console.error('API error:', error);
    this.toastr.error('An error occurred. Please try again later.');
  }
);

}

  cancelAdd() {
    this.showAddForm = false;
    this.newItem = { carSize: '', labourItem: '', mrp: '', status: '' };
  }

startEdit(index: number) {
  this.editIndex = index;
  const selectedRow = this.listData[index];
  this.editItem = {
    labourItem: selectedRow.labourName,
    mrp: selectedRow.labourAmount.toString(),
    carSize: selectedRow.carSize,
    status: selectedRow.status,
  };
}
saveEdit(matchedItem: any) {
  if (this.editIndex !== null) {
    this.editLabour(matchedItem, this.editItem);
    this.editIndex = null;
  }
}

labourList() {
  this.aspLoadingService.show();
  const garageKey = localStorage.getItem('garageKey');

  this.aspRatecardSettingService.getGarageLabourRateCard(garageKey).subscribe(
    (response: any) => {
      this.aspLoadingService.hide();
      this.dataMap = response.data; // Store the full data for table lookup
      // this.companies = Object.keys(response.data); // Extract all the company keys
       // Optionally set the first company as selected
      this.dataMap = response.data.rateCards || {}; // Store rateCards
      this.companies = response.data.rateCardTypes || []; // Store rateCardTypes
this.selectedCompany = this.companies[0];
      // console.log("Available companies:", this.companies);
      // console.log("Selected company:", this.selectedCompany);
      this.loadTableData();

 // Load table data based on the default selected company
    },
    (error) => {
      console.error('Error fetching labour list:', error);
    }
  );
}

// editLabour(matchedItem: any, editedItem: any): void {
//   const garageKey = localStorage.getItem('garageKey'); // 🔹 Get garageKey from localStorage
//   const garageName = localStorage.getItem('spareSelectedGarageName');
//   const payload = {
//     id: matchedItem.id,
//     labourId: matchedItem.labourId,
//     garageKey: garageKey,
    
//     labourName: editedItem.labourItem,
//     labourAmount: Number(editedItem.mrp.replace(/[^0-9.-]+/g, '')),
//     carSize: editedItem.carSize,
//     rateCardType: this.selectedCompany,
//      status: editedItem.status ? 1 : 0
//   };

//   this.aspRatecardSettingService.editLabourItem(payload).subscribe(
//     (editResponse: any) => {
//       // console.log('Labour item updated successfully', editResponse);
//       // this.ngOnInit();
      
//     },
//     (error) => {
//       console.error('Error updating labour item', error);
//     }
//   );
// }
editLabour(matchedItem: any, editedItem: any): void {
  const garageKey = localStorage.getItem('garageKey');
  const payload = {
    id: matchedItem.id,
    labourId: matchedItem.labourId,
    garageKey: garageKey,
    labourName: editedItem.labourItem,
    labourAmount: Number(editedItem.mrp.replace(/[^0-9.-]+/g, '')),
    carSize: editedItem.carSize,
    rateCardType: this.selectedCompany,
    status: editedItem.status ? 1 : 0
  };

  this.aspRatecardSettingService.editLabourItem(payload).subscribe(
    (editResponse: any) => {
      // ✅ Update the item in dataMap
      const companyData = this.dataMap[this.selectedCompany];
      const index = companyData.findIndex((item) => item.id === payload.id);

      if (index !== -1) {
        companyData[index] = { ...companyData[index], ...payload };
        this.dataMap[this.selectedCompany] = companyData;
        this.loadTableData(); // ✅ Refresh visible list
      }

      this.toastr.success('Labour item updated successfully');
    },
    (error) => {
      console.error('Error updating labour item', error);
      this.toastr.error('Failed to update labour item.');
    }
  );
}


cancelEdit() {
  this.editIndex = null;
}
saveLabel() {
  // console.log('Label Saved:', this.labelName);
   // Add to companies if not already present
  if (this.labelName && !this.companies.includes(this.labelName)) {
    this.companies.push(this.labelName);
  }
  this.showLabelPopup = false;
  this.labelName = '';
}
}
